import { API } from "aws-amplify";
import { toast } from "react-toastify";

export const GET_SITE_OWNER_NOTIFICATION_LIST_REQUEST =
  "@@ownerNotification/GET_SITE_OWNER_NOTIFICATION_LIST_REQUEST";
export const GET_SITE_OWNER_NOTIFICATION_LIST_SUCCESS =
  "@@ownerNotification/GET_SITE_OWNER_NOTIFICATION_LIST_SUCCESS";
export const GET_SITE_OWNER_NOTIFICATION_LIST_FAILURE =
  "@@ownerNotification/GET_SITE_OWNER_NOTIFICATION_LIST_FAILURE";

export function getOwnerNotificationList(siteId) {
  return async (dispatch) => {
    if (!siteId) return;
    dispatch({
      type: GET_SITE_OWNER_NOTIFICATION_LIST_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/site/${siteId}/owner-notification`,
      );
      dispatch({
        type: GET_SITE_OWNER_NOTIFICATION_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SITE_OWNER_NOTIFICATION_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_OWNER_NOTIFICATION_REQUEST =
  "@@ownerNotification/GET_OWNER_NOTIFICATION_REQUEST";
export const GET_OWNER_NOTIFICATION_SUCCESS =
  "@@ownerNotification/GET_OWNER_NOTIFICATION_SUCCESS";
export const GET_OWNER_NOTIFICATION_FAILURE =
  "@@ownerNotification/GET_OWNER_NOTIFICATION_FAILURE";

export function getOwnerNotification(siteId, id) {
  return async (dispatch) => {
    if (!siteId) return;
    dispatch({
      type: GET_OWNER_NOTIFICATION_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/site/${siteId}/owner-notification/${id}`,
      );
      dispatch({
        type: GET_OWNER_NOTIFICATION_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_OWNER_NOTIFICATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CREATE_SITE_OWNER_NOTIFICATION_REQUEST =
  "@@ownerNotification/CREATE_SITE_OWNER_NOTIFICATION_REQUEST";
export const CREATE_SITE_OWNER_NOTIFICATION_SUCCESS =
  "@@ownerNotification/CREATE_SITE_OWNER_NOTIFICATION_SUCCESS";
export const CREATE_SITE_OWNER_NOTIFICATION_FAILURE =
  "@@ownerNotification/CREATE_SITE_OWNER_NOTIFICATION_FAILURE";

export function createOwnerNotification(siteId, formData) {
  return async (dispatch) => {
    if (!siteId) return;

    dispatch({
      type: CREATE_SITE_OWNER_NOTIFICATION_REQUEST,
    });
    const init = {
      body: formData,
    };
    try {
      const response = await API.post(
        "cmsAPI",
        `/site/${siteId}/owner-notification`,
        init,
      );
      dispatch({
        type: CREATE_SITE_OWNER_NOTIFICATION_SUCCESS,
        payload: response,
      });
      dispatch(getOwnerNotificationList(siteId));
    } catch (error) {
      dispatch({
        type: CREATE_SITE_OWNER_NOTIFICATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_OWNER_NOTIFICATION =
  "@@ownerNotification/CLEAR_OWNER_NOTIFICATION";

export function clearOwnerNotification() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_OWNER_NOTIFICATION,
    });
  };
}

export const GET_GLOBAL_OWNER_NOTIFICATION_LIST_REQUEST =
  "@@ownerNotification/GET_GLOBAL_OWNER_NOTIFICATION_LIST_REQUEST";
export const GET_GLOBAL_OWNER_NOTIFICATION_LIST_SUCCESS =
  "@@ownerNotification/GET_GLOBAL_OWNER_NOTIFICATION_LIST_SUCCESS";
export const GET_GLOBAL_OWNER_NOTIFICATION_LIST_FAILURE =
  "@@ownerNotification/GET_GLOBAL_OWNER_NOTIFICATION_LIST_FAILURE";

export function getGlobalOwnerNotificationList() {
  return async (dispatch) => {
    dispatch({
      type: GET_GLOBAL_OWNER_NOTIFICATION_LIST_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/owner-notification`);
      dispatch({
        type: GET_GLOBAL_OWNER_NOTIFICATION_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_GLOBAL_OWNER_NOTIFICATION_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_OWNER_NOTIFICATION_TEMPLATE_LIST_REQUEST =
  "@@ownerNotification/GET_OWNER_NOTIFICATION_TEMPLATE_LIST_REQUEST";
export const GET_OWNER_NOTIFICATION_TEMPLATE_LIST_SUCCESS =
  "@@ownerNotification/GET_OWNER_NOTIFICATION_TEMPLATE_LIST_SUCCESS";
export const GET_OWNER_NOTIFICATION_TEMPLATE_LIST_FAILURE =
  "@@ownerNotification/GET_OWNER_NOTIFICATION_TEMPLATE_LIST_FAILURE";

export function getOwnerNotificationTemplateList(published_only = false) {
  return async (dispatch) => {
    dispatch({
      type: GET_OWNER_NOTIFICATION_TEMPLATE_LIST_REQUEST,
    });
    try {
      const query = published_only ? "?filter__published__exists" : "";
      const response = await API.get(
        "cmsAPI",
        `/owner-notification-template${query}`,
      );
      dispatch({
        type: GET_OWNER_NOTIFICATION_TEMPLATE_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_OWNER_NOTIFICATION_TEMPLATE_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_OWNER_NOTIFICATION_TEMPLATE_REQUEST =
  "@@ownerNotification/GET_OWNER_NOTIFICATION_TEMPLATE_REQUEST";
export const GET_OWNER_NOTIFICATION_TEMPLATE_SUCCESS =
  "@@ownerNotification/GET_OWNER_NOTIFICATION_TEMPLATE_SUCCESS";
export const GET_OWNER_NOTIFICATION_TEMPLATE_FAILURE =
  "@@ownerNotification/GET_OWNER_NOTIFICATION_TEMPLATE_FAILURE";

export function getOwnerNotificationTemplate(id) {
  return async (dispatch) => {
    dispatch({
      type: GET_OWNER_NOTIFICATION_TEMPLATE_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/owner-notification-template/${id}`,
      );
      dispatch({
        type: GET_OWNER_NOTIFICATION_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_OWNER_NOTIFICATION_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const CREATE_OWNER_NOTIFICATION_TEMPLATE_REQUEST =
  "@@ownerNotification/CREATE_OWNER_NOTIFICATION_TEMPLATE_REQUEST";
export const CREATE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS =
  "@@ownerNotification/CREATE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS";
export const CREATE_OWNER_NOTIFICATION_TEMPLATE_FAILURE =
  "@@ownerNotification/CREATE_OWNER_NOTIFICATION_TEMPLATE_FAILURE";

export function createOwnerNotificationTemplate(formData, callback) {
  return async (dispatch) => {
    dispatch({
      type: CREATE_OWNER_NOTIFICATION_TEMPLATE_REQUEST,
    });
    const init = {
      body: formData,
    };
    try {
      const response = await API.post(
        "cmsAPI",
        `/owner-notification-template`,
        init,
      );
      dispatch({
        type: CREATE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS,
        payload: response,
      });

      toast.success("Owner notification template added successfully.");
      if (callback) {
        callback(true);
      }
    } catch (error) {
      dispatch({
        type: CREATE_OWNER_NOTIFICATION_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const UPDATE_OWNER_NOTIFICATION_TEMPLATE_REQUEST =
  "@@ownerNotification/UPDATE_OWNER_NOTIFICATION_TEMPLATE_REQUEST";
export const UPDATE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS =
  "@@ownerNotification/UPDATE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS";
export const UPDATE_OWNER_NOTIFICATION_TEMPLATE_FAILURE =
  "@@ownerNotification/UPDATE_OWNER_NOTIFICATION_TEMPLATE_FAILURE";

export function updateOwnerNotificationTemplate(id, formData, callback) {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_OWNER_NOTIFICATION_TEMPLATE_REQUEST,
    });
    const init = {
      body: formData,
    };
    try {
      const response = await API.put(
        "cmsAPI",
        `/owner-notification-template/${id}`,
        init,
      );
      dispatch({
        type: UPDATE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS,
        payload: response,
      });
      toast.success("Owner notification template updated successfully.");
      if (callback) {
        callback(true);
      }
    } catch (error) {
      dispatch({
        type: UPDATE_OWNER_NOTIFICATION_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const DELETE_OWNER_NOTIFICATION_TEMPLATE_REQUEST =
  "@@ownerNotification/DELETE_OWNER_NOTIFICATION_TEMPLATE_REQUEST";
export const DELETE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS =
  "@@ownerNotification/DELETE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS";
export const DELETE_OWNER_NOTIFICATION_TEMPLATE_FAILURE =
  "@@ownerNotification/DELETE_OWNER_NOTIFICATION_TEMPLATE_FAILURE";

export function deleteOwnerNotificationTemplate(id) {
  return async (dispatch) => {
    dispatch({
      type: DELETE_OWNER_NOTIFICATION_TEMPLATE_REQUEST,
    });
    try {
      const response = await API.del(
        "cmsAPI",
        `/owner-notification-template/${id}`,
      );
      dispatch({
        type: DELETE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS,
        payload: response,
      });
      dispatch(getOwnerNotificationTemplateList());
    } catch (error) {
      dispatch({
        type: DELETE_OWNER_NOTIFICATION_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_OWNER_NOTIFICATION_TEMPLATE =
  "@@ownerNotification/CLEAR_OWNER_NOTIFICATION_TEMPLATE";

export function clearOwnerNotificationTemplate() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_OWNER_NOTIFICATION,
    });
  };
}
